// Important: this file is generated from the 'build' script and should not be
// edited directly
export var version = '4.0.0';
//# sourceMappingURL=version.js.map